import "./NewEngineering.css";
import "./serviceEditor.css";
import { NavLink } from "react-router-dom";
import Avatar1 from '../../Images/construction_.jpg';
import Aboutbg from '../../Images/s5.png';
import { ServiceEditModal, usePageEditor, resolveUrl } from "./serviceEditorShared";

const servicesNav = [
  { label: "Engineering",                    href: "/engineering" },
  { label: "Procurement",                    href: "/procurement" },
  { label: "Construction",                   href: "/construction" },
  { label: "Installation & Instrumentation", href: "/installation-instrumentation" },
  { label: "Commissioning",                  href: "/commissioning" },
  { label: "Manpower-supply",                href: "/manpower-supply" },
  { label: "Marine Support",                 href: "/marine-support" },
];

const DEFAULT_DATA = {
  bannerImage: "",
  bgImage: "",
  title: "Our Construction division delivers high-quality, safe, and efficient solutions across a wide range of sectors, including oil & gas, infrastructure, energy, and industrial facilities.",
  paragraphs: [
    "Backed by experienced professionals and robust project management systems, we execute civil, mechanical, structural, and electrical construction works to international standards. From site preparation and fabrication to installation and commissioning, we are committed to delivering projects within budget and with a strong focus on safety and quality.",
    "Our ability to manage complex construction environments ensures seamless integration with engineering and procurement functions for optimal project delivery.",
  ],
  sections: [],
};

export default function Construction() {
  const { pageData, loading, fetchErr, fetchData, modalOpen, setModalOpen, saving, handleSave, saveMsg } =
    usePageEditor("/api/construction", DEFAULT_DATA);

  const bannerImg = resolveUrl(pageData.bannerImage) || Avatar1;
  const bgImg     = resolveUrl(pageData.bgImage)     || Aboutbg;

  return (
    <>
      <button className="edit-fab" onClick={() => setModalOpen(true)} title="Edit page content">
        <span className="edit-fab__icon">✏️</span>
        <span className="edit-fab__label">Edit Page</span>
      </button>

      {saveMsg  && <div className="editor-toast">{saveMsg}</div>}
      {loading  && <div className="editor-loading"><div className="editor-loading__spinner" /></div>}
      {fetchErr && <div className="editor-error-banner">{fetchErr}<button onClick={fetchData}>Retry</button></div>}
      {modalOpen && (
        <ServiceEditModal data={pageData} onSave={handleSave} onClose={() => setModalOpen(false)} saving={saving} pageLabel="Construction" />
      )}

      <div className="img_carriercon">
        <img src={bannerImg} alt="" />
      </div>

      <section className="service-detail" style={{ backgroundImage: `url(${bgImg})` }}>
        <div className="service-detail__layout">
          <div className="service-detail__content">
            <h2 className="service-detail__title">{pageData.title}</h2>
            <span className="service-detail__divider" />
            {pageData.paragraphs.map((p, i) => <p key={i} className="service-detail__intro">{p}</p>)}
            {pageData.sections.map((sec, i) => (
              <div key={i} className="service-detail__section">
                <h3 className="service-detail__section-heading">{sec.heading}</h3>
                <ul className="service-detail__list">
                  {sec.items.map((item, j) => <li key={j} className="service-detail__list-item">{item}</li>)}
                </ul>
              </div>
            ))}
          </div>
          <nav className="service-detail__tabs" aria-label="Service navigation">
            {servicesNav.map((s) => (
              <NavLink key={s.href} to={s.href} className={({ isActive }) => `service-detail__tab${isActive ? " service-detail__tab--active" : ""}`}>
                {s.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </section>
    </>
  );
}
